module.exports = __webpack_public_path__ + "img/wind.91ec5dd3.svg";